<template>

  <div :class="[$style.FormSectionBankAccount]">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4 class="textColor"> Bank Account Details</h4>
    </div>
    <template>
      <UiTextField
        v-model="innerValue.accountNumber"
        ref="accountNumberField"
        name="accountNumber"
        type="number"
        tabindex="1"
        :class="[$style.formIte043m, { [$style._oneLine]: isOneLine }]"
        :hasError="$isFieldInvalid('innerValue.accountNumber')"
        :errorText="$t('FormSectionBankAccount.accountNumberInvalid')"
        :label="$t('FormSectionBankAccount.accountNumber')"
        @input="emitChanges('accountNumber')"
      />

      <UiTextField
        v-model="innerValue.routingNumber"
        ref="routingNumberField"
        name="routingNumber"
        type="number"
        tabindex="2"
        :class="[$style.formIte043m, { [$style._oneLine]: isOneLine }]"
        :hasError="$isFieldInvalid('innerValue.routingNumber')"
        :errorText="$t('FormSectionBankAccount.routingNumberInvalid')"
        :label="$t('FormSectionBankAccount.routingNumber')"
        @input="emitChanges('routingNumber')"
      />

      <UiSelect
        name="accountType"
        v-model="innerValue.accountType"
        maxHeight="240px"
        :options="accountType"
        :placeholderLabel="$t('FormSectionBankAccount.accountType')"
        :hasReversible="true"
        :hasError="$isFieldInvalid('innerValue.accountType')"
        :errorText="$t('FormSectionBankAccount.accountTypeInvalid')"
        tabindex="3"
        @select="emitChanges('accountType')"
      />

    </template>

    <div class="billingfields">
      <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
        <UiTextField
          v-model="innerValue.firstname"
          name="First Name"
          :class="$style.formItem"
          :label="$t('FormSectionBankAccount.firstname')"
          :hasError="$isFieldInvalid('innerValue.firstname')"
          :errorText="$t('FormSectionBankAccount.firstnameInvalid')"
          tabindex="4"
          @input="emitChanges('firstname')"
        />

        <UiTextField
          v-model="innerValue.lastname"
          name="Last Name"
          :class="$style.formItem"
          :label="$t('FormSectionBankAccount.lastname')"
          :hasError="$isFieldInvalid('innerValue.lastname')"
          :errorText="$t('FormSectionBankAccount.lastnameInvalid')"
          tabindex="5"
          @input="emitChanges('lastname')"
        />
      </div>

      <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
        <UiTextField
          v-model="innerValue.email"
          name="email"
          type="email"
          :class="$style.formItem"
          :label="$t('FormSectionBankAccount.email')"
          :hasError="$isFieldInvalid('innerValue.email')"
          :errorText="$t('FormSectionBankAccount.emailInvalid')"
          tabindex="6"
          @input="emitChanges('email')"
        />
      </div>

      </div>

      <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
        <UiTextField
          v-model="innerValue.city"
          name="city"
          :class="$style.formItem"

          :label="$t('FormSectionBankAccount.city')"
          :hasError="$isFieldInvalid('innerValue.city')"
          :errorText="$t('FormSectionBankAccount.cityInvalid')"
          tabindex="8"
          @input="emitChanges('city')"
        />

        <UiSelect
          name="state"
          v-model="innerValue.state"
          maxHeight="240px"
          style="width: 50%;"
          :options="states"
          :placeholderLabel="$t('FormSectionBankAccount.state')"
          :hasReversible="true"
          :hasError="$isFieldInvalid('innerValue.state')"
          :errorText="$t('FormSectionBankAccount.stateInvalid')"
          tabindex="9"
          @select="emitChanges('state')"
        />
      </div>
      <p>I hereby authorize <strong>{{ this.dbaName }}</strong> to initiate ACH debits to my bank account. I understand I may revoke this authorization by calling/emailing <strong>+1 877 203 6624</strong> or <strong>support@payarc.com</strong> within 3 business days prior to the authorized processing date. </p>

<!--      <span v-if="this.surcharge > 0.0" style="font-size:12px; font-weight:bold">Merchant has applied a Convenience fee of ${{ this.surcharge / 100 }} USD to this transaction. </span>-->
    </div>

</template>

<script>
import {
  required,
  requiredIf,
  email,
  maxLength,
  minLength,
} from 'vuelidate/lib/validators';
import { extend } from 'lodash-es';
import UiSelect from './UiSelect.vue';
import UiTextField from './UiTextField.vue';


export default {
  name: 'FormSectionBankAccount',

  components: {
    UiTextField,
    UiSelect,
  },

  props: {
    value: {
      type: Object,
    },
    isOneLine: {
      type: Boolean,
      default: false,
    },
    surcharge: {
      type: Number,
      default: 0.0,
    },
    dbaName: {
      type: String,
      default: '',
    },
    approvedSecCodes: {
      type: Array,
      default: () => [],
    },
    // A recurring (subscription) ACH order must attach to a reconcilable customer so future
    // rebills resolve by customer_id; the backend (ChargeOrderAction) rejects it without an
    // email. One-off ACH charges don't need one, so the field is only required when the parent
    // signals a subscription is selected.
    isEmailRequired: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  computed: {
    accountType() {
      const options = [];
      if (this.approvedSecCodes.includes('WEB')) {
        options.push(
          { label: 'Personal Checking', value: 'Personal Checking' },
          { label: 'Personal Savings', value: 'Personal Savings' },
        );
      }
      if (this.approvedSecCodes.includes('CCD')) {
        options.push(
          { label: 'Business Checking', value: 'Business Checking' },
          { label: 'Business Savings', value: 'Business Savings' },
        );
      }
      return options;
    },
  },

  data() {
    return {
      states: [
        {label: 'Alabama', value: 'AL'},
        {label: 'Alaska', value: 'AK'},
        {label: 'Arizona', value: 'AZ'},
        {label: 'Arkansas', value: 'AR'},
        {label: 'California', value: 'CA'},
        {label: 'Colorado', value: 'CO'},
        {label: 'Connecticut', value: 'CT'},
        {label: 'Delaware', value: 'DE'},
        {label: 'Florida', value: 'FL'},
        {label: 'Georgia', value: 'GA'},
        {label: 'Hawaii', value: 'HI'},
        {label: 'Idaho', value: 'ID'},
        {label: 'Illinois', value: 'IL'},
        {label: 'Indiana', value: 'IN'},
        {label: 'Iowa', value: 'IA'},
        {label: 'Kansas', value: 'KS'},
        {label: 'Kentucky', value: 'KY'},
        {label: 'Louisiana', value: 'LA'},
        {label: 'Maine', value: 'ME'},
        {label: 'Maryland', value: 'MD'},
        {label: 'Massachusetts', value: 'MA'},
        {label: 'Michigan', value: 'MI'},
        {label: 'Minnesota', value: 'MN'},
        {label: 'Mississippi', value: 'MS'},
        {label: 'Missouri', value: 'MO'},
        {label: 'Montana', value: 'MT'},
        {label: 'Nebraska', value: 'NE'},
        {label: 'Nevada', value: 'NV'},
        {label: 'New Hampshire', value: 'NH'},
        {label: 'New Jersey', value: 'NJ'},
        {label: 'New Mexico', value: 'NM'},
        {label: 'New York', value: 'NY'},
        {label: 'North Carolina', value: 'NC'},
        {label: 'North Dakota', value: 'ND'},
        {label: 'Ohio', value: 'OH'},
        {label: 'Oklahoma', value: 'OK'},
        {label: 'Oregon', value: 'OR'},
        {label: 'Pennsylvania', value: 'PA'},
        {label: 'Rhode Island', value: 'RI'},
        {label: 'South Carolina', value: 'SC'},
        {label: 'South Dakota', value: 'SD'},
        {label: 'Tennessee', value: 'TN'},
        {label: 'Texas', value: 'TX'},
        {label: 'Utah', value: 'UT'},
        {label: 'Vermont', value: 'VT'},
        {label: 'Virginia', value: 'VA'},
        {label: 'Washington', value: 'WA'},
        {label: 'West Virginia', value: 'WV'},
        {label: 'Wisconsin', value: 'WI'},
        {label: 'Wyoming', value: 'WY'},
        {label: 'American Samoa', value: 'AS'},
        {label: 'District of Columbia', value: 'DC'},
        {label: 'Federated States of Micronesia', value: 'FM'},
        {label: 'Guam', value: 'GU'},
        {label: 'Marshall Islands', value: 'MH'},
        {label: 'Northern Mariana Islands', value: 'MP'},
        {label: 'Palau', value: 'PW'},
        {label: 'Puerto Rico', value: 'PR'},
        {label: 'Virgin Islands', value: 'VI'},
      ],
      innerValue: extend({}, this.value),
    };
  },

  watch: {
    value: {
      handler(value) {
        extend(this.innerValue, value);
      },
      deep: true,
    },
  },

  validations() {
    return {
      innerValue: {
        accountNumber: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(17),
        },
        routingNumber: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9),
        },

        firstname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
        lastname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
        accountType: {
          required,
        },
        email: {
          required: requiredIf(function emailRequired() {
            return this.isEmailRequired;
          }),
          email,
        },
      },
    };
  },

  mounted() {
    this.focusAccountNumberField();
  },

  methods: {
    getInnerValue() {
      return this.innerValue;
    },

    focusAccountNumberField() {
      this.$nextTick(() => {
        if (this.$refs.accountNumberField) {
          this.$refs.accountNumberField.focus();
        }
      });
    },

    emitChanges(key) {
      console.log('emitChanges', key, this.innerValue[key]);
      // For v-model
      this.$emit('change', this.innerValue);
      const value = this.innerValue[key];
      // to watch certain field
      this.$emit(`${key}Change`, value);
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
};
</script>
<style type="text/css">
button#paybtn:disabled {
  background-color: #d0d0d0;
}

.3
dcardhidden {
  width: 0px;
  padding: 0px;
  height: 0px;
  margin: 0;
  border: none;
}

.billingfields {
  width: 100%;
}

.arrow-right {
  border: solid #000;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transition: .5s;
  -webkit-transform: rotate(320deg);
  margin-left: 3px;
}

.arrow-down {
  border: solid #000;
  transition: .5s;
  border-width: 0 3px 3px 0;
  display: inline-block;
  margin-left: 3px;
  padding: 3px;
  -webkit-transform: rotate(405deg);
}
</style>
<style module lang="scss">
/* arrowdown:after {*/
/*  content: ' \2B9F';*/
/*}*/

.FormSectionBankAccount {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  justify-content: space-between;
}

.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}

.expiry {
  @include if-ltr {
    margin-right: 20px;
  }
}

.hiddenExpiry {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
  width: calc(50% - 10px);

  @include if-rtl {
    left: auto;
    right: 0;
  }
}

.remember {
  padding: 18px 0;
}

.rememberInfo {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  margin: 0 6px;
}


</style>
